import React, { useEffect, useState } from "react";
import { formatDistanceToNow } from "date-fns";

import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  useNotify,
  useRedirect,
  useEditController,
  Edit,
  FormTab,
  SaveButton,
  TabbedForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { logError } from "../../../utils/appUtils";
import { ApproveIcon } from "../../../components/common/iconography";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { NoteType, AuditStatus } from "../../../utils/constants";
import OperatorsList from "../../../crewApp/pages/audit/OperatorsList";
import LocationsMap from "../../../crewApp/pages/audit/LocationsMap";
import AuditSummary from "./AuditSummary";
import { AuditEditHelp } from "./AuditHelp";
import { AuditEditAside } from "./AuditEditAside";
import { DeepDeleteButton } from "./DeepDeleteButton";
import { AuditReconcileTab } from "./AuditReconcileTab";
import { AuditReportTab } from "./AuditReportTab";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(2),
  },
  progress: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 300,
  },
  operators: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    flexWrap: "wrap",
  },
  item: {
    margin: theme.spacing(0.5),
  },
  saveButton: {
    marginRight: theme.spacing(2),
  },
}));

const parseAuditData = (record, notify) => {
  const audit = { ...record };
  if (audit) {
    try {
      debugger;
      if (typeof audit.processedItems === "string") {
        audit.processedItems = !audit.processedItems
          ? []
          : JSON.parse(audit.processedItems);
        audit.processedItems = audit.processedItems.map((itm) => {
          return {
            ...itm,
            seeNotes:
              itm.notes &&
              itm.notes.findIndex(
                (note) =>
                  note.type === NoteType.AUDIT &&
                  note.date >= audit.createdAt &&
                  note.date <=
                    (audit.endDateTime ? audit.endDateTime : audit.updatedAt)
              ) >= 0,
          };
        });
      }
      if (typeof audit.skippedItems === "string") {
        audit.skippedItems = !audit.skippedItems
          ? []
          : JSON.parse(audit.skippedItems);
      }
      if (typeof audit.processedLocations === "string") {
        audit.processedLocations = !audit.processedLocations
          ? {}
          : JSON.parse(audit.processedLocations);
      }

      if (Array.isArray(audit.processedItems))
        audit.reconcileList = audit.processedItems.filter(
          (itm) => itm.quantityMismatch || itm.seeNotes
        );
      else audit.reconcileList = [];
    } catch (error) {
      logError("audits:AuditEdit:parseAuditData:Parsing JSON", error, notify);
    }
  }
  return audit;
};

const AuditStatusTab = ({ record, parsedAudit, locations, ...props }) => {
  const classes = useStyles();

  if (record.status === AuditStatus.IN_PROGRESS)
    return (
      <Grid container direction="column" spacing={1}>
        <Grid container direction="row" spacing={1}>
          <Grid item xs={12}>
            {true && (
              <Typography>{`Created: ${formatDistanceToNow(
                new Date(record.createdAt)
              )} ago`}</Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <LocationsMap currentAudit={parsedAudit} locations={locations} />
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={1}>
          <Grid item xs={12}>
            <OperatorsList
              currentAudit={record}
              locations={locations}
              classes={classes}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={1}>
          <Grid item xs={12}>
            <TextInput
              source="notes"
              label="Notes"
              variant="outlined"
              multiline
              minRows={4}
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    );
  else
    return (
      <Grid container direction="column" spacing={1} className={classes.root}>
        <Grid container direction="row" spacing={1}>
          <Grid item xs={12}>
            <AuditSummary currentAudit={parsedAudit} />
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={1}>
          <Grid item xs={12}>
            <TextInput
              source="notes"
              label="Notes"
              variant="outlined"
              multiline
              minRows={4}
              fullWidth
              disabled={record.status === AuditStatus.COMPLETED}
            />
          </Grid>
        </Grid>
      </Grid>
    );
};

const AuditEditActions = ({ basePath, data, ...props }) => (
  <TopToolbar>
    <HelpButton>
      <AuditEditHelp {...props} />
    </HelpButton>
    <BackButton basePath={basePath} />
  </TopToolbar>
);

export const AuditEdit = (props) => {
  const classes = useStyles();
  const notify = useNotify();
  const redirect = useRedirect();
  const { record } = useEditController(props);
  const [parsedAudit, setParsedAudit] = useState();
  let locations = record?.locations;

  useEffect(() => {
    if (record) setParsedAudit(parseAuditData(record, notify));
  }, [record]);

  const completeTransform = (data) => {
    debugger;
    data.status = AuditStatus.COMPLETED;
    return transform(data);
  };

  const transform = (data) => {
    debugger;
    delete data.reconcileList;
    return data;
  };

  const onSuccess = async ({ data }) => {
    debugger;
    notify(`Audit updated successfully.`);
    redirect("/audits");
  };

  const onFailure = (error) => {
    logError("audits:AuditEdit:onFailure:Audit Update", error, notify);
  };

  const AuditEditToolbar = (props) => {
    debugger;
    return (
      record.status !== AuditStatus.COMPLETED && (
        <Toolbar style={{ justifyContent: "space-between" }} {...props}>
          <div>
            <SaveButton
              label="Save"
              {...props}
              disabled={props.pristine}
              className={classes.saveButton}
              transform={transform}
              onSuccess={onSuccess}
              onFailure={onFailure}
            />
            {record.status === AuditStatus.PENDING_REVIEW && (
              <SaveButton
                label="Mark Complete"
                {...props}
                icon={<ApproveIcon />}
                transform={completeTransform}
                onSuccess={onSuccess}
                onFailure={onFailure}
              />
            )}
          </div>
          {record.status === AuditStatus.IN_PROGRESS && <DeepDeleteButton />}
        </Toolbar>
      )
    );
  };

  if (!parsedAudit) return null;
  return (
    <Edit
      {...props}
      title={<ForceTitle title="Edit Audit" />}
      undoable={false}
      actions={<AuditEditActions {...props} />}
      aside={
        <AuditEditAside record={record} locations={locations} {...props} />
      }
    >
      <TabbedForm
        variant="outlined"
        submitOnEnter={false}
        toolbar={<AuditEditToolbar {...props} record={record} />}
      >
        <FormTab label="Audit Status">
          <AuditStatusTab
            {...props}
            record={record}
            parsedAudit={parsedAudit}
            locations={locations}
          />
        </FormTab>
        {record.status !== AuditStatus.IN_PROGRESS && (
          <FormTab label="Reconcile Sheet">
            <AuditReconcileTab {...props} record={parsedAudit} />
          </FormTab>
        )}
        {record.status !== AuditStatus.IN_PROGRESS && (
          <FormTab label="Audit Report">
            <AuditReportTab {...props} record={parsedAudit} />
          </FormTab>
        )}
      </TabbedForm>
    </Edit>
  );
};
